import styled from "styled-components/macro";

export const Container = styled.section`
  width: 75%;
  margin: 0 10px;

  input {
    margin-bottom: 50px;
  }
`;